module.exports = __webpack_public_path__ + "img/s4.638bc73f.png";